import React from 'react';
import {GridRowsProp, GridToolbarContainer} from "@mui/x-data-grid";

import {Button} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import NotificationsIcon from "@mui/icons-material/Notifications";
import UnsubscribeIcon from "@mui/icons-material/Unsubscribe";
import DeleteIcon from "@mui/icons-material/Delete";
import EditContactDialog from './dialogs/EditContactDialog';
import ConfirmationDialog from "./dialogs/ConfirmationDialog";
import useModalStore from "../../stores/useModalStore";
import useContactsStore from "../../stores/useContactsStore";
import useClientQuery from "../../../../global/queries/useClientQuery";
import {Contact} from "../../interfaces/Contact";
import usePostChangeQuery from "../../../../global/queries/usePostChangeQuery";
import {v4 as uuid} from "uuid";
import {Change, status} from "../../../../global/interfaces/Change";

interface TableToolbarProps {
    rowSelectionModel: GridRowsProp;
    setRowSelectionModel: (newSelectedRows: (oldSelectedRows: GridRowsProp) => GridRowsProp) => void;

}

export default function TableToolbar({ rowSelectionModel, setRowSelectionModel }: TableToolbarProps) {

    const {toggleIsEditContactDialogOpen} = useModalStore();
    const {setCurrentContact} = useContactsStore();

    const {data: client} = useClientQuery()

    const {contacts, updateContact, removeContact} = useContactsStore();

    const query = usePostChangeQuery();
    const handleAddContactClick = () => {
        setCurrentContact("", true, client?.suchname)
        toggleIsEditContactDialogOpen()
    };

    const handleNewsletterClick = (isNewsletter: boolean) => {
        let selectedRowsData = rowSelectionModel.map((id) => {
            console.log(id)
            console.log(contacts[2].name)
            return contacts.find((contact) => contact.name === id.toString())
        });


        selectedRowsData.forEach((contact) => {

            updateContact(contact?.name || "", {...contact, newsletter: isNewsletter} as Contact)

            const change: Change = {
                datum: new Date().toISOString(),
                feld: "newsletter",
                id: uuid(),
                name: contact?.name,
                status: status.PENDING,
                suchname: contact?.suchname,
                wertAenderung: isNewsletter,
                wertOriginal: contact?.newsletter || false
            }

            query.mutate(change)
        })

        setRowSelectionModel(() => [])
    }

    const handleDeleteClick = () => {
        let selectedRowsData = rowSelectionModel.map((id) => {
            console.log(id)
            console.log(contacts[2].name)
            return contacts.find((contact) => contact.name === id.toString())
        });

        selectedRowsData.forEach((contact) => {
            removeContact(contact?.name || "")
            const change: Change = {
                datum: new Date().toISOString(),
                feld: "delete",
                id: uuid(),
                name: contact?.name,
                status: status.PENDING,
                suchname: contact?.suchname,
                wertAenderung: "",
                wertOriginal: ""
            }

            query.mutate(change)
        })

        setRowSelectionModel(() => [])
    }

    return (
        <>
            <GridToolbarContainer sx={{backgroundColor: "secondary.main"}}>
                <Button color="primary" startIcon={<AddCircleOutlineIcon/>} onClick={handleAddContactClick}>
                    Kontakt hinzufügen
                </Button>
                <Button color="primary" startIcon={<NotificationsIcon/>} onClick={() => {
                    handleNewsletterClick(true)
                }}>
                    Newsletter abonnieren
                </Button>
                <Button color="primary" startIcon={<UnsubscribeIcon/>} onClick={() => {
                    handleNewsletterClick(false)
                }}>
                    Newsletter abbestellen
                </Button>
                <Button color="primary" startIcon={<DeleteIcon/>} onClick={handleDeleteClick}>
                    Kontakte Löschen
                </Button>
            </GridToolbarContainer>
            <EditContactDialog/>

            <ConfirmationDialog/>
        </>
    );


}